module.exports = __webpack_public_path__ + "static/img/2.784d4cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/eng/2.png
// module id = IYgu
// module chunks = 0